import { Link } from "react-router-dom";

import HomeCovers from "~/components/HomeCovers";
import Categories from "~/components/Categories";
import GalleryPreview from "~/components/GalleryPreview";
import BubbleContact from "~/components/BubbleContact";

import { getLink, trans } from "~/providers/lang";
import { ROUTES, SHOW_CHRISTMAS } from '~/const';
import { useSeo } from "~/hooks/useSeo";
import ChristmasOpening from "~/components/ChristmasOpening";
import { mainStore } from "~/stores/main";
import MainVideo from "~/components/MainVideo";

import "./style.less";

export default function HomePage() {
	const isSmallDevice = mainStore(state => state.data.isSmallDevice);

	useSeo({
		title: trans("skelet.title.home"),
		canonical: "",
	});

	return <div className="home-page">
		{ isSmallDevice && <div className="home-page-mobile">
			<img src="/img/main-logo-new.png?1" className="main-logo-mobile" alt="" />
			<MainVideo className="homePageVideo" title={trans("home.news.item33")} />
			<h2 className="homePageSubtitle" dangerouslySetInnerHTML={{ __html: trans("home.news.item34") }}></h2>
		</div> }
		{ !isSmallDevice && <HomeCovers /> }
		<Categories />
		<GalleryPreview />
		<div className="body-background page-content">
			<div className="news">
				{ !isSmallDevice && <h2 className="mainPageTitle">
					{trans('home.title')}
				</h2> }
				<p className="news-text" dangerouslySetInnerHTML={{ __html: trans('home.news.item28') }} data-item="28" />
				{ SHOW_CHRISTMAS && <ChristmasOpening /> }
				<p className="news-text">
					<img src="/img/promo2.jpg?2" alt={trans('common.imageAlt')} className="gallery-href with-border" loading="lazy" />
				</p>
				<p className="news-text skalica-show" data-item="22">
					<span className="col-md-12 title">
						{trans('home.news.item32')}
					</span>
					<iframe className="col-md-12" id="youtubeCont1" title="youtube cont" frameBorder={0} allowFullScreen={true} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" width={600} height={360} src="https://www.youtube.com/embed/8WRvQ8vgHVg?enablejsapi=1" />
				</p>
				<div className="centered-content" data-item="29">
					<div className="centered-content-inner">
						<span className="title">
							{trans('home.news.item29')}
						</span>
						<Link to={getLink(ROUTES.galleryAction)} className="covers">
							<span className="img-cover">
								<img src="/galerie-satu/akce/akce-s-711.jpeg" alt={trans('common.imageAlt')} loading="lazy" className="with-border click" />
							</span>
							<span className="img-cover">
								<img src="/galerie-satu/akce/akce-s-704.jpeg" alt={trans('common.imageAlt')} loading="lazy" className="with-border click" />
							</span>
							<span className="img-cover">
								<img src="/galerie-satu/akce/akce-s-697.jpeg" alt={trans('common.imageAlt')} loading="lazy" className="with-border click" />
							</span>
						</Link>
						<span className="link">
							<Link to={getLink(ROUTES.galleryAction)}>
								{trans('common.gallery.enter')}
							</Link>
						</span>
					</div>
				</div>
				<p className="news-text" data-item="3">
					<Link to={getLink(ROUTES.galleryWedding)} style={{ display: "block", marginBottom: "10px" }}>
						<img src="/img/new-collection-2021.jpg" alt={trans('common.imageAlt')} className="gallery-href with-border click" loading="lazy" />
					</Link>
					<span dangerouslySetInnerHTML={{ __html: trans('home.news.item3') }} />
				</p>
				<p className="news-text" data-item="4">
					<img src="/galerie-satu/spolecenske/spolecenske-saty-l-138.jpg" alt="Módní přehlídka 2021" className="gallery-href with-border" loading="lazy" /><br /><br />
					<span dangerouslySetInnerHTML={{ __html: trans('home.news.item4') }} />
				</p>
				<p className="news-text skalica-show" data-item="22">
					<span className="col-md-12 title">
						{trans('home.news.item22')}
					</span>
					<iframe className="col-md-12" id="youtubeCont2" title="youtube cont" frameBorder={0} allowFullScreen={true} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" width={600} height={360} src="https://www.youtube.com/embed/oUosbQQT7mE?enablejsapi=1" />
				</p>
				<div className="centered-content" data-item="21">
					<div className="centered-content-inner">
						<span className="title">
							{trans('home.news.item21')}
						</span>
						<Link to={`${getLink(ROUTES.galleryAction)}?strana=4`} className="covers">
							<span className="img-cover">
								<img src="/galerie-satu/akce/akce-s-587.jpg" alt={trans('common.imageAlt')} loading="lazy" className="with-border click" />
							</span>
							<span className="img-cover">
								<img src="/galerie-satu/akce/akce-s-577.jpg" alt={trans('common.imageAlt')} loading="lazy" className="with-border click" />
							</span>
							<span className="img-cover">
								<img src="/galerie-satu/akce/akce-s-581.jpg" alt={trans('common.imageAlt')} loading="lazy" className="with-border click" />
							</span>
						</Link>
						<span className="link">
							<Link to={`${getLink(ROUTES.galleryAction)}?strana=4`}>
								{trans('common.gallery.enter')}
							</Link>
						</span>
					</div>
				</div>
				<h2 className="news-text" data-item="5">
					{trans('home.news.item5')}
				</h2>
				<div className="centered-content" data-item="29">
					<div className="centered-content-inner">
						<Link to={getLink(ROUTES.galleryAction)} className="covers">
							<span className="img-cover">
								<img src="/galerie-satu/akce/akce-s-242.jpg" alt={trans('common.imageAlt')} className="gallery-href with-border click" loading="lazy" />
							</span>
						</Link>
						<Link to={getLink(ROUTES.galleryAddons)} className="covers covers-max-width">
							<span className="img-cover">
								<img src="/galerie-satu/doplnky/doplnky-s-037.jpg" className="promo-vert with-border click" alt={trans('common.imageAlt')} loading="lazy" />
							</span>
							<span className="img-cover">
								<img src="/galerie-satu/doplnky/doplnky-s-032.jpg" className="promo-vert with-border click" alt={trans('common.imageAlt')} loading="lazy" />
							</span>
							<span className="img-cover">
								<img src="/galerie-satu/doplnky/doplnky-s-025.jpg" className="promo-vert with-border click" alt={trans('common.imageAlt')} loading="lazy" />
							</span>
							<span className="img-cover">
								<img src="/galerie-satu/doplnky/doplnky-s-018.jpg" className="promo-img with-border click" alt={trans('common.imageAlt')} loading="lazy" />
							</span>
							<span className="img-cover">
								<img src="/galerie-satu/doplnky/doplnky-s-042.jpg" className="promo-img with-border click" alt={trans('common.imageAlt')} loading="lazy" />
							</span>
							<span className="img-cover">
								<img src="/galerie-satu/doplnky/doplnky-s-017.jpg" className="promo-img with-border click" alt={trans('common.imageAlt')} loading="lazy" />
							</span>
							<span className="img-cover">
								<img src="/galerie-satu/doplnky/doplnky-s-043.jpg" className="promo-img with-border click" alt={trans('common.imageAlt')} loading="lazy" />
							</span>
						</Link>
					</div>
				</div>
				<div className="centered-content" data-item="11">
					<div className="centered-content-inner">
						<span className="title">
							{trans('home.news.item11')}
						</span>
						<Link to={`${getLink(ROUTES.galleryAction)}?strana=4`} className="covers">
							<span className="img-cover">
								<img src="/galerie-satu/akce/akce-s-411.jpg" alt={trans('common.imageAlt')} loading="lazy" className="with-border click" />
							</span>
							<span className="img-cover">
								<img src="/galerie-satu/akce/akce-s-410.jpg" alt={trans('common.imageAlt')} loading="lazy" className="with-border click" />
							</span>
							<span className="img-cover">
								<img src="/galerie-satu/akce/akce-s-409.jpg" alt={trans('common.imageAlt')} loading="lazy" className="with-border click" />
							</span>
						</Link>
						<span className="link">
							<Link to={`${getLink(ROUTES.galleryAction)}?strana=4`} className="covers col-md-12">
								{trans('common.gallery.enter')}
							</Link>
						</span>
					</div>
				</div>
				<div className="centered-content" data-item="6">
					<div className="centered-content-inner">
						<span className="title">
							{trans('home.news.item6')}
						</span>
						<Link to={`${getLink(ROUTES.galleryAction)}?strana=7`} className="covers">
							<span className="img-cover">
								<img src="/galerie-satu/akce/akce-s-359.jpg" alt={trans('common.imageAlt')} loading="lazy" className="with-border click" />
							</span>
							<span className="img-cover">
								<img src="/galerie-satu/akce/akce-s-358.jpg" alt={trans('common.imageAlt')} loading="lazy" className="with-border click" />
							</span>
							<span className="img-cover">
								<img src="/galerie-satu/akce/akce-s-357.jpg" alt={trans('common.imageAlt')} loading="lazy" className="with-border click" />
							</span>
						</Link>
						<span className="link">
							<Link to={`${getLink(ROUTES.galleryAction)}?strana=7`}>
								{trans('common.gallery.enter')}
							</Link>
						</span>
					</div>
				</div>
				<p className="news-text" dangerouslySetInnerHTML={{ __html: trans('home.news.item8') }} data-item="8" />
				<BubbleContact />
				<div className="credits">
					<p dangerouslySetInnerHTML={{ __html: trans('home.credits.info') }} />
				</div>
			</div>
		</div>
	</div>;
}
